module.exports = [{
      plugin: require('/tmp/7b9c9d7c/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"google":{"families":["Saira"]}},
    }]
